import PropTypes from 'prop-types';
import React from 'react';

const buildReviewRow = (title, key) => (
  <div key={key} className="review-row">
    <dt />
    <dd className="dd-privacy-hidden" data-dd-action-name="data value">
      {title}
    </dd>
  </div>
);

const DemographicReviewField = ({ children }) => {
  const { formData, schema, uiSchema } = children.props;
  const categories = Object.keys(schema.properties).filter(
    prop => formData[prop],
  );

  if (categories.length) {
    return categories.map(field =>
      buildReviewRow(uiSchema[field]['ui:title'], field),
    );
  }

  return buildReviewRow('None selected');
};

DemographicReviewField.propTypes = {
  children: PropTypes.shape({
    props: PropTypes.shape({
      formData: PropTypes.object,
      schema: PropTypes.object,
      uiSchema: PropTypes.object,
    }),
  }),
};

export default DemographicReviewField;
